import Vue from 'vue'
import moment from 'moment'

const filters = {
  'dateformat': (date, format = 'YYYY-MM-DD HH:mm') => {
    if (moment(date).isSame('0001-01-01', 'year')) {
      return '未知'
    }
    return moment(date).format(format)
  },
  'expire': (second) => {
    if (second >= '3153600000') {
      return '永久'
    } else if (second > 31536000) {
      return `${(second / 31536000).toFixed(2)}年`
    } else if (second > 2592000) {
      return `${(second / 2592000).toFixed(2)}月`
    } else if (second > 604800) {
      return `${(second / 604800).toFixed(2)}周`
    } else if (second > 86400) {
      return `${(second / 86400).toFixed(2)}天`
    } else if (second > 3600) {
      return `${(second / 3600).toFixed(2)}小时`
    } else if (second > 60) {
      return `${(second / 60).toFixed(2)}分钟`
    } else {
      return `${second}秒`
    }
  }
}

export default {
  register: () => {
    for (const key in filters) {
      Vue.filter(key, filters[key])
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/filters.js